<template>
  <div class="kd-text-alignment">
    <!-- top row -->
    <div class="kd-text-alignment__row kd-text-alignment__row--top">
      <div
        class="kd-text-alignment__button kd-text-alignment__button--top-left"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.LEFT,
            y: directions.TOP})
          }"
        @click="alignmentButtonClicked({ x: directions.LEFT, y: directions.TOP})"
      >
        <img
          :src="iconUrl({ x: directions.LEFT, y: directions.TOP})"
          class="kd-text-alignment__icon"
        >
      </div>
      <div
        class="kd-text-alignment__button kd-text-alignment__button--top-center"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.CENTER,
            y: directions.TOP
          })
        }"
        @click="alignmentButtonClicked({ x: directions.CENTER, y: directions.TOP})"
      >
        <img
          :src="iconUrl({ x: directions.CENTER, y: directions.TOP})"
          class="kd-text-alignment__icon"
        >
      </div>
      <div
        class="kd-text-alignment__button kd-text-alignment__button--top-right"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.RIGHT,
            y: directions.TOP
          })
        }"
        @click="alignmentButtonClicked({ x: directions.RIGHT, y: directions.TOP})"
      >
        <img
          :src="iconUrl({ x: directions.RIGHT, y: directions.TOP})"
          class="kd-text-alignment__icon"
        >
      </div>
    </div>
    <!-- center row -->
    <div class="kd-text-alignment__row kd-text-alignment__row--top">
      <div
        class="kd-text-alignment__button kd-text-alignment__button--center-left"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.LEFT,
            y: directions.CENTER
          })
        }"
        @click="alignmentButtonClicked({ x: directions.LEFT, y: directions.CENTER})"
      >
        <img
          :src="iconUrl({ x: directions.LEFT, y: directions.CENTER})"
          class="kd-text-alignment__icon"
        >
      </div>
      <div
        class="kd-text-alignment__button kd-text-alignment__button--center-center"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.CENTER,
            y: directions.CENTER
          })
        }"
        @click="alignmentButtonClicked({ x: directions.CENTER, y: directions.CENTER})"
      >
        <img
          :src="iconUrl({ x: directions.CENTER, y: directions.CENTER})"
          class="kd-text-alignment__icon"
        >
      </div>
      <div
        class="kd-text-alignment__button kd-text-alignment__button--center-right"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.RIGHT,
            y: directions.CENTER
          })
        }"
        @click="alignmentButtonClicked({ x: directions.RIGHT, y: directions.CENTER})"
      >
        <img
          :src="iconUrl({ x: directions.RIGHT, y: directions.CENTER})"
          class="kd-text-alignment__icon"
        >
      </div>
    </div>
    <!-- bottom row -->
    <div class="kd-text-alignment__row kd-text-alignment__row--top">
      <div
        class="kd-text-alignment__button kd-text-alignment__button--bottom-left"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.LEFT,
            y: directions.BOTTOM
          })
        }"
        @click="alignmentButtonClicked({ x: directions.LEFT, y: directions.BOTTOM})"
      >
        <img
          :src="iconUrl({ x: directions.LEFT, y: directions.BOTTOM})"
          class="kd-text-alignment__icon"
        >
      </div>
      <div
        class="kd-text-alignment__button kd-text-alignment__button--bottom-center"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.CENTER,
            y: directions.BOTTOM
          })
        }"
        @click="alignmentButtonClicked({ x: directions.CENTER, y: directions.BOTTOM})"
      >
        <img
          :src="iconUrl({ x: directions.CENTER, y: directions.BOTTOM})"
          class="kd-text-alignment__icon"
        >
      </div>
      <div
        class="kd-text-alignment__button kd-text-alignment__button--bottom-right"
        :class="{
          'kd-text-alignment__button--active': isCurrentAlignment({
            x: directions.RIGHT,
            y: directions.BOTTOM
          })
        }"
        @click="alignmentButtonClicked({ x: directions.RIGHT, y: directions.BOTTOM})"
      >
        <img
          :src="iconUrl({ x: directions.RIGHT, y: directions.BOTTOM})"
          class="kd-text-alignment__icon"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import directionTypes from '@/shared/directions';

import {
  SET_TEXT_ALIGNMENT_FOR_ACTIVE_LAYER,
} from '@/store/mutation-types';

export default {
  props: {
    alignmentX: {
      required: true,
      type: String,
    },
    alignmentY: {
      required: true,
      type: String,
    },
  },
  /* eslint-disable global-require */
  // is there a better way??
  data() {
    return {
      iconAlignLeft: require('../assets/images/icons/align-left.svg'),
      iconAlignLeftActive: require('../assets/images/icons/align-left-white.svg'),
      iconAlignCenter: require('../assets/images/icons/align-center.svg'),
      iconAlignCenterActive: require('../assets/images/icons/align-center-white.svg'),
      iconAlignRight: require('../assets/images/icons/align-right.svg'),
      iconAlignRightActive: require('../assets/images/icons/align-right-white.svg'),
    };
  },
  computed: {
    directions() { return directionTypes; },
  },
  methods: {
    ...mapMutations([
      SET_TEXT_ALIGNMENT_FOR_ACTIVE_LAYER,
    ]),
    iconUrl({ x, y }) {
      const buttonActive = this.isCurrentAlignment({ x, y });
      switch (x) {
        case this.directions.LEFT:
          if (buttonActive) { return this.iconAlignLeftActive; }
          return this.iconAlignLeft;
        case this.directions.CENTER:
          if (buttonActive) { return this.iconAlignCenterActive; }
          return this.iconAlignCenter;
        case this.directions.RIGHT:
          if (buttonActive) { return this.iconAlignRightActive; }
          return this.iconAlignRight;
        default:
          return '';
      }
    },
    isCurrentAlignment({ x, y }) {
      return this.alignmentX === x && this.alignmentY === y;
    },
    /**
     * @param {String} param1 e.g. { x: directionTypes.LEFT, y: directionTypes.TOP }
     */
    alignmentButtonClicked({ x, y }) {
      this.SET_TEXT_ALIGNMENT_FOR_ACTIVE_LAYER({ x, y });
    },
  },
};
</script>

<style lang="scss">
.kd-text-alignment__button {
  cursor: pointer;
  background-color: #EDEDED;
  height: 23px;
  width: 30%;
  padding: 5px;
  display: flex;

  &--active {
    background-color: #01A3DF;
  }

  &--top-left {
    border-radius: 3px 0 0 0;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &--top-center {
    justify-content: center;
    align-items: flex-start;
  }
  &--top-right {
    border-radius: 0 3px 0 0;
    justify-content: flex-end;
    align-items: flex-start;
  }
  &--center-left {
    justify-content: flex-start;
    align-items: center;
  }
  &--center-center {
    justify-content: center;
    align-items: center;
  }
  &--center-right {
    justify-content: flex-end;
    align-items: center;
  }
  &--bottom-left {
    border-radius: 0 0 0 3px;
    justify-content: flex-start;
    align-items: flex-end;
  }
  &--bottom-center {
    border-radius: 0 0 0 3px;
    justify-content: center;
    align-items: flex-end;
  }
  &--bottom-right {
    justify-content: flex-end;
    align-items: flex-end;
  }
}

.kd-text-alignment__row {
  margin-bottom: 9px;
  display: flex;
  flex-direction: row;

  .kd-text-alignment__button:first-child { margin-right: 9px; }
  .kd-text-alignment__button:last-child { margin-left: 9px; }
}
</style>
